import React, { useEffect, useRef, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Box, Button, makeStyles, TextField, Typography } from '@material-ui/core';
import { PageLayout } from '@/shared/components/PageLayout';
import { MonitoringInfoTable, rowsPerPageSetting } from '@/pages/Monitoring/Table';
import { client } from '@/shared/api';
import { DropDownHashCode } from './components/DropDown';
import { useGetDashboardsInfo } from './services/hooks/use-get-hashboards';
const uuid = (index) => `${Math.random()}_${index ? index : Math.random()}_${new Date().getTime()}`;
const PATH_AUTH_API = 'Admin';
let hashTagsForRequest = '';
const useStyles = makeStyles((theme) => ({
    colorButtons: {
        backgroundColor: '#0066CC',
        color: 'white',
        height: '40px',
        minWidth: '127px',
        borderRadius: '0px',
    },
    openFilterText: {
        marginRight: '10px',
        fontSize: '14px'
    },
    openFilterButton: {
        backgroundColor: '#0066CC',
        color: 'white',
        borderRadius: '0px',
    },
    filterButton: {
        backgroundColor: '#0066CC',
        color: 'white',
        borderRadius: '0px',
        height: '40px',
    },
    messageText: {
        minWidth: '240px',
        height: '56px',
    },
}));
const decodeString = (codeType) => {
    const stringBytes = new TextEncoder().encode(codeType);
    const base64String = btoa(String.fromCharCode(...stringBytes));
    return base64String;
};
const DEFAULT_PAGE_SIZE = 50;
const PAGE_NUMBER_PARAM = 'pageNumber';
const PAGE_SIZE_PARAM = 'pageSize';
// Пагинация хранится в query-параметрах, чтобы после F5 открывалась та же страница.
// Невалидные значения из адресной строки заменяются значениями по умолчанию.
const parsePagination = (search) => {
    const params = new URLSearchParams(search);
    const pageNumber = Number(params.get(PAGE_NUMBER_PARAM));
    const pageSize = Number(params.get(PAGE_SIZE_PARAM));
    return {
        pageNumber: Number.isInteger(pageNumber) && pageNumber > 0 ? pageNumber : 1,
        pageSize: rowsPerPageSetting.includes(pageSize) ? pageSize : DEFAULT_PAGE_SIZE,
    };
};
export const Monitoring = () => {
    const history = useHistory();
    const { search } = useLocation();
    const { pageNumber, pageSize } = parsePagination(search);
    const [users, setDashboards] = useState();
    const [value, setValue] = useState('');
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [message, setMessage] = useState('');
    const [dashboardType, setDashboardType] = useState('');
    const [hashTags, setHashTags] = useState('');
    const [valueDescription, setValueDescription] = useState([]);
    const [columnFilters, setColumnFilters] = useState({
        chainType: '',
        currentStage: '',
        stateOnHead: '',
        stateOnAgents: '',
        integrationChainState: '',
    });
    const [selectedIds, setSelectedIds] = useState([]);
    const { data: infos } = useGetDashboardsInfo();
    const messagesDescriptionKeys = users?.possibleFilters?.messagesDescriptionKeys || infos?.possibleFilters?.messagesDescriptionKeys || [];
    const chainTypes = users?.possibleFilters?.chainTypeCodes || infos?.possibleFilters?.chainTypeCodes || [];
    const currentStages = users?.possibleFilters?.stageTypeCodes || infos?.possibleFilters?.stageTypeCodes || [];
    const statesOnHead = users?.possibleFilters?.statesOnHead || infos?.possibleFilters?.statesOnHead || [];
    const statesOnAgents = users?.possibleFilters?.statesOnAgents || infos?.possibleFilters?.statesOnAgents || [];
    const integrationChainStates = users?.possibleFilters?.integrationChainStates || infos?.possibleFilters?.integrationChainStates || [];
    const startDatetoISO = startDate ? startDate.toISOString() : null;
    const endDatetoISO = endDate ? endDate.toISOString() : null;
    const dashBoardTypetoBase64 = decodeString(dashboardType);
    // const queryHashTags = (data && isSuccess) ? ([...data?.hashTags].reduce((acc, curr) => acc + `&HashTags=${curr}`, '')) : '';
    const styles = useStyles();
    // Номер последнего запроса: ответ на более старый запрос (например, при быстром наборе
    // в поле "Описание значения") не должен перезаписать результат более нового.
    const lastRequestId = useRef(0);
    async function executeFetch(additionalRequest) {
        lastRequestId.current += 1;
        const requestId = lastRequestId.current;
        const data = await fetchInfo(additionalRequest);
        if (requestId === lastRequestId.current) {
            setDashboards(data);
        }
    }
    const setPagination = (nextPageNumber, nextPageSize, replace = false) => {
        const params = new URLSearchParams(history.location.search);
        params.set(PAGE_NUMBER_PARAM, String(nextPageNumber));
        params.set(PAGE_SIZE_PARAM, String(nextPageSize));
        const location = { search: `?${params.toString()}` };
        if (replace) {
            history.replace(location);
        }
        else {
            history.push(location);
        }
    };
    // Со сменой фильтра текущий номер страницы теряет смысл.
    // replace - чтобы смена фильтров не засоряла историю браузера.
    const resetPage = () => {
        setPagination(1, pageSize, true);
    };
    const totalPages = users?.totalPages ?? 0;
    // После смены фильтров или ручной правки URL страница может оказаться за пределами списка.
    useEffect(() => {
        if (totalPages > 0 && pageNumber > totalPages) {
            setPagination(totalPages, pageSize, true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [totalPages, pageNumber, pageSize]);
    // useEffect(() => {
    //     // executeFetch('');
    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, []);
    const [, setIsOpenUserDrawer] = useState(false);
    const handleClickRowByUsersTable = async (dashboard) => {
        try {
            const dashboardInfomation = Object.assign({}, users);
            if (dashboard.isShowStageInfo === undefined || dashboard.isShowStageInfo === false) {
                const { data } = await client.get(`${PATH_AUTH_API}/GetMessageStagesInfo/${dashboard.messageId}`);
                if (data) {
                    dashboardInfomation?.dashboardInfos?.forEach((element) => {
                        if (dashboard.messageId === element.messageId) {
                            element.messageStage = data;
                            element.isShowStageInfo = true;
                        }
                    });
                }
            }
            else {
                dashboardInfomation?.dashboardInfos?.forEach((element) => {
                    if (dashboard.messageId === element.messageId) {
                        element.isShowStageInfo = false;
                    }
                });
            }
            setDashboards(dashboardInfomation);
        }
        catch (e) {
            console.error(e);
            return undefined;
        }
    };
    const handleClear = (_e) => {
        setValue('');
        setStartDate(null);
        setEndDate(null);
        setDashboardType('');
        setMessage('');
        setValueDescription([]);
        setHashTags('');
        setColumnFilters({
            chainType: '',
            currentStage: '',
            stateOnHead: '',
            stateOnAgents: '',
            integrationChainState: '',
        });
        resetPage();
    };
    const handleClickRow = (value) => {
        if (value) {
            hashTagsForRequest = '';
            value.forEach((element) => {
                if (hashTagsForRequest.length > 0) {
                    hashTagsForRequest += `${'&HashTags='}${element}`;
                }
                else {
                    hashTagsForRequest = `&HashTags=${element}`;
                }
            });
            setHashTags(hashTagsForRequest);
            resetPage();
        }
        setIsOpenUserDrawer(false);
    };
    // const handleClickSearch = () => {
    //     const inputValue = (document.getElementById('search-bar-input') as HTMLInputElement).value;
    //     const searchForRequest = inputValue.length > 0 ? `value=${inputValue}` : '';
    //     let result = '';
    //     if (hashTagsForRequest.length > 0) {
    //         result = `?${hashTagsForRequest}`;
    //     }
    //     if (searchForRequest.length > 0 && result.length > 0) {
    //         result += `&${searchForRequest}`;
    //     } else if (result.length === 0) {
    //         result = `?${searchForRequest}`;
    //     }
    //     executeFetch(result);
    // };
    const handleChangePage = (page) => {
        setPagination(page, pageSize);
    };
    const handleChangeRowsPerPage = (size) => {
        setPagination(1, size);
    };
    async function fetchInfo(additionalRequest) {
        try {
            const { data } = await client.get(`${PATH_AUTH_API}/GetDashboardInfo${additionalRequest}`);
            return data;
        }
        catch (e) {
            console.error(e);
            return undefined;
        }
    }
    const handleSetMessage = (event) => {
        setMessage(event.target.value);
    };
    const handleFilterDashboardsInfo = () => {
        const columnFiltersQuery = `&chain-type-query=${columnFilters.chainType}&current-stage-query=${columnFilters.currentStage}&state-on-head-query=${columnFilters.stateOnHead}&state-on-agents-query=${columnFilters.stateOnAgents}&integration-chain-state-query=${columnFilters.integrationChainState}`;
        executeFetch(`?chain-type-code-query=${dashboardType ? dashBoardTypetoBase64 : ''}&chain-instantiated-from=${startDate ? startDatetoISO : ''}&chain-instantiated-to=${endDate ? endDatetoISO : ''}&Value=${message ? message : ''}${hashTags}${columnFiltersQuery}&PageNumber=${pageNumber}&PageSize=${pageSize}`);
    };
    const handleColumnFilterChange = (column, value) => {
        setColumnFilters(prev => ({ ...prev, [column]: value }));
        resetPage();
    };
    const handleStartDateChange = (newDate) => {
        setStartDate(newDate);
        resetPage();
    };
    const handleEndDateChange = (newDate) => {
        setEndDate(newDate);
        resetPage();
    };
    const handleSelectRow = (id) => {
        setSelectedIds(prev => prev.includes(id) ? prev.filter(i => i !== id) : [...prev, id]);
    };
    const handleSelectAll = (ids) => {
        setSelectedIds(ids);
    };
    const handleResumeMessages = async () => {
        try {
            await Promise.all(selectedIds.map(id => client.post(`${PATH_AUTH_API}/ReturnMessageToWorkflowQueueAfterMessageWasPaused`, { messageGuid: id })));
            setSelectedIds([]);
            handleFilterDashboardsInfo();
        }
        catch (e) {
            console.error(e);
        }
    };
    useEffect(() => {
        handleFilterDashboardsInfo();
    }, [columnFilters, dashboardType, startDate, endDate, message, hashTags, pageNumber, pageSize]);
    return (React.createElement(React.Fragment, null,
        React.createElement(PageLayout, null,
            React.createElement(Box, { mb: 3, display: "flex", justifyContent: "flex-end" }, selectedIds.length > 0 && (React.createElement(Box, { mr: 2 },
                React.createElement(Button, { className: styles.openFilterButton, onClick: handleResumeMessages },
                    React.createElement(Typography, { className: styles.openFilterText }, "\u0412\u043E\u0437\u043E\u0431\u043D\u043E\u0432\u0438\u0442\u044C"))))),
            React.createElement(Box, { mb: 3, display: 'flex', justifyContent: 'flex-start', width: "100%" },
                React.createElement(Box, { display: 'flex', alignItems: 'flex-end', flexGrow: 1 },
                    React.createElement(DropDownHashCode, { onClickRow: (value) => handleClickRow(value), valueDescription: valueDescription, setValueDescription: setValueDescription, options: messagesDescriptionKeys })),
                React.createElement(Box, { display: "flex", alignItems: "flex-end", flexGrow: 1 },
                    React.createElement(TextField, { id: "outlined-basic", label: "\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044F", placeholder: "\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044F", variant: "outlined", className: styles.messageText, value: message, onChange: (e) => {
                            setMessage(e.target.value);
                            resetPage();
                        }, onKeyPress: (e) => {
                            if (e.key === 'Enter') {
                                handleFilterDashboardsInfo();
                            }
                        }, fullWidth: true }))),
            users === undefined ? (React.createElement("p", null, "Loading...")) : (React.createElement(Box, { height: "75vh" },
                React.createElement(MonitoringInfoTable, { dashboards: users, onClickRow: handleClickRowByUsersTable, totalPages: totalPages, pageSize: pageSize, currentPage: pageNumber, onChangePage: handleChangePage, onChangeRowsPerPage: handleChangeRowsPerPage, columnFilters: columnFilters, onColumnFilterChange: handleColumnFilterChange, startDate: startDate, endDate: endDate, onStartDateChange: handleStartDateChange, onEndDateChange: handleEndDateChange, filterOptions: {
                        chainType: chainTypes,
                        currentStage: currentStages,
                        stateOnHead: statesOnHead,
                        stateOnAgents: statesOnAgents,
                        integrationChainState: integrationChainStates,
                    }, selectedIds: selectedIds, onSelectRow: handleSelectRow, onSelectAll: handleSelectAll }))))));
};
